import { Components } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";
import { Loader } from "../../../../../../../Common";
import VideoProps from "./Video";
import { ButtonContainer, Container, VideoUploadContainer } from "./style";

const VideoUpload = ({ fileInputRef }: VideoProps.IProps) => {
  const { typography } = useTheme();
  const { setIsVideoOpen, setPostContentOrder } = useContext(
    CreatePostModalContext
  );
  const { post_id } = useAppSelector((state) => state.posts);
  const { video_id, isUploading } = useAppSelector((state) => state.postVideo);

  return (
    <VideoUploadContainer
      onClick={() => fileInputRef?.current?.click()}
      $isUploading={isUploading}
    >
      <Container>
        <Components.IconButton
          kind="Primary"
          size={"Large"}
          disabled={false}
          iconType="Video"
          onClick={() => {}}
        />
        <Components.Text
          style={{ tokenStyle: typography.Heading["S"] }}
          text="Add Video"
          fontWeight="font-weight-semibold"
          lineHeight={"line-height-400"}
        />
        <Components.Text
          style={{ tokenStyle: typography.Body["S"] }}
          text="Or drag and drop here"
          fontWeight="font-weight-semibold"
          lineHeight={"line-height-50"}
        />
        <ButtonContainer>
          <Components.IconButton
            disabled={false}
            iconType="X"
            kind="Secondary"
            onClick={(e) => {
              e.stopPropagation();
              API_CALLS.POSTVIDEO.deleteVideoFromAPost({
                post_id,
                video_id,
              });
              setIsVideoOpen(false);
              setPostContentOrder((prev) =>
                prev.includes("video")
                  ? prev.filter((item) => item !== "video")
                  : prev
              );
            }}
            size="Small"
          />
        </ButtonContainer>
      </Container>
      {isUploading && <Loader />}
    </VideoUploadContainer>
  );
};

export default VideoUpload;
